/*
 * Module for suppression.
 */

define([
  "jquery",
  "marionette",
  "underscore",
  "messaging/messenger",
  "modules/topicsSplit/topic/topicExampleModal/suppression/suppressionView",
], function ($, Marionette, _, Messenger, SuppressionView) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "suppression";
      this._setUpVents();
    },
    show: function (example) {
      const _this = this;
      this.exampleModel = example;
      this.exampleModel.message = "";
      this.view = new SuppressionView.suppressionView({ model: this.exampleModel });
      this.languages = Messenger.reqres.request("kb:languages");
      this.touchPoints = Messenger.reqres.request("kb:touchpoints");
      this.allLocaleName = "All";
      this.allTouchPointName = "All";
      this.allLocaleId = -1;
      this.allTouchPointId = -1;

      this.autocompleteSuppressedPairs = example.pairsCol;
      //suppressed touchpoints and locales array is only used for display purpose and to have the
      //ability to multi-select locales and touchpoints
      this.autocompleteSuppressedTouchPoints = this.buildAutocompleteSuppressedTouchPoints();
      this.autocompleteSuppressedLocales = this.buildAutocompleteSuppressedLocales();
      this.exampleModel.autocompleteSuppressedTouchPoints = this.autocompleteSuppressedTouchPoints;
      this.exampleModel.autocompleteSuppressedLocales = this.autocompleteSuppressedLocales;
      this.view.model.autocompleteSuppressedLocales = this.autocompleteSuppressedLocales;
      this.view.on(
        "toggle:suppress",
        function () {
          //"Suppress from Autocomplete" checkbox was clicked
          const autocompleteSuppressed = !example.get("autocompleteSuppressed");
          example.set("autocompleteSuppressed", autocompleteSuppressed);
          this.updateFlags();
          if (autocompleteSuppressed) {
            // Make sure the "All" Locale is selected when autocomplete suppressed is initially checked
            _.each(this.autocompleteSuppressedLocales, function (locale, index) {
              if (index === 0) {
                locale.suppressed = true;
              } else {
                locale.suppressed = false;
              }
            });
            // Make sure the "All" TouchPoint is selected when autocomplete suppressed is initially checked
            _.each(this.autocompleteSuppressedTouchPoints, function (touchPoint, index) {
              if (index === 0) {
                touchPoint.suppressed = true;
              } else {
                touchPoint.suppressed = false;
              }
            });
          } else {
            this._suppressNoLocales();
            this._suppressNoTouchPoints();
            this._removeAllPairs();
          }
          this.view.render();
        },
        this,
      );

      this.view.on(
        "change:suppressionLocales",
        function (locales) {
          //if both locale and touchpoint drop down has "None" selected then automatically uncheck the
          // "Suppress from Autocomplete" checkbox, if even one of them is changed from "None", then check/select the
          //"Suppress from Autocomplete" checkbox
          let anyLocaleSuppressed = false;
          let allLocaleSuppressed = false;
          const autocompleteSuppressedLocales = this.autocompleteSuppressedLocales;
          _.each(autocompleteSuppressedLocales, function (locale, index) {
            const suppressed = _.contains(locales, locale.languageId);
            if (index === 0) {
              allLocaleSuppressed = suppressed;
              anyLocaleSuppressed = suppressed;
              locale.suppressed = suppressed;
            } else {
              if (allLocaleSuppressed) {
                locale.suppressed = false;
              } else {
                locale.suppressed = suppressed;
                if (suppressed) {
                  anyLocaleSuppressed = suppressed;
                }
              }
            }
          });
          this.updateAutoCompleteSuppressedStatus(anyLocaleSuppressed);
          if (!anyLocaleSuppressed) {
            autocompleteSuppressedLocales[0].suppressed = true;
            allLocaleSuppressed = true;
          }
        },
        this,
      );

      this.view.on(
        "change:suppressionTouchPoints",
        function (touchPoints) {
          //if both locale and touchpoint drop down has "None" selected then automatically uncheck the
          // "Suppress from Autocomplete" checkbox, if even one of them is changed from "None", then check/select the
          //"Suppress from Autocomplete" checkbox
          let anyTouchPointSuppressed = false;
          let allTouchPointSuppressed = false;
          const autocompleteSuppressedTouchPoints = this.autocompleteSuppressedTouchPoints;
          _.each(autocompleteSuppressedTouchPoints, function (touchPoint, index) {
            const suppressed = _.contains(touchPoints, touchPoint.touchPointId);
            if (index === 0) {
              allTouchPointSuppressed = suppressed;
              anyTouchPointSuppressed = suppressed;
              touchPoint.suppressed = suppressed;
            } else {
              if (allTouchPointSuppressed) {
                touchPoint.suppressed = false;
              } else {
                touchPoint.suppressed = suppressed;
                if (suppressed) {
                  anyTouchPointSuppressed = suppressed;
                }
              }
            }
          });
          this.updateAutoCompleteSuppressedStatus(anyTouchPointSuppressed);
          if (!anyTouchPointSuppressed) {
            autocompleteSuppressedTouchPoints[0].suppressed = true;
            allTouchPointSuppressed = true;
          }
        },
        this,
      );

      this.view.on(
        "add:pairs:for:suppression",
        function () {
          let safeToAdd = true;
          this.autocompleteSuppressedPairs.each(function (pair) {
            if (
              safeToAdd &&
              pair.get("languageId") === this.allLocaleId &&
              pair.get("touchPointId") === this.allTouchPointId
            ) {
              //if all and all selection already exists, do not let user add any new pair.
              //To add any new pair, all and all should be first deleted.
              this.exampleModel.message = $.t(
                "topic.example.suppressedPair.allAndAllAlreadySuppressed",
              );
              safeToAdd = false;
            }
          }, this);
          if (!safeToAdd) {
            this._clearSelectionAndRender();
            return;
          }
          //get all selected locales for suppression
          const autocompleteSuppressedLocales = this.autocompleteSuppressedLocales;
          let selectedLocaleIds = [];
          let isAllLocaleSelected = false;
          _.each(
            autocompleteSuppressedLocales,
            function (locale) {
              if (locale.suppressed) {
                selectedLocaleIds.push(locale.languageId);
                if (locale.languageId === this.allLocaleId) {
                  isAllLocaleSelected = true;
                }
              }
            },
            this,
          );
          if (selectedLocaleIds.length === 0) {
            this.exampleModel.message = $.t("topic.example.suppressedPair.selectAtleastOneLocale");
            this._clearSelectionAndRender();
            return;
          }
          //get all selected touchpoints for suppression
          const autocompleteSuppressedTouchPoints = this.autocompleteSuppressedTouchPoints;
          let selectedTouchpointIds = [];
          let isAllTouchpointSelected = false;
          _.each(
            autocompleteSuppressedTouchPoints,
            function (touchpoint) {
              if (touchpoint.suppressed) {
                selectedTouchpointIds.push(touchpoint.touchPointId);
                if (touchpoint.touchPointId === this.allTouchPointId) {
                  isAllTouchpointSelected = true;
                }
              }
            },
            this,
          );
          if (selectedTouchpointIds.length === 0) {
            this.exampleModel.message = $.t(
              "topic.example.suppressedPair.selectAtleastOneTouchpoint",
            );
            this._clearSelectionAndRender();
            return;
          }

          if (isAllLocaleSelected && isAllTouchpointSelected) {
            //no need to add any other pairs, just add All and All
            selectedLocaleIds = [];
            selectedLocaleIds.push(this.allLocaleId);
            selectedTouchpointIds = [];
            selectedTouchpointIds.push(this.allTouchPointId);
          }

          //construct all <locale, touchpoints> pairs for suppression
          const selectedCombinations = [];
          let safeToAddAllAndAll = true;
          selectedLocaleIds.forEach(function (localeId) {
            selectedTouchpointIds.forEach(function (touchPointId) {
              if (
                safeToAddAllAndAll &&
                this.autocompleteSuppressedPairs.length > 0 &&
                localeId === this.allLocaleId &&
                touchPointId === this.allTouchPointId
              ) {
                safeToAddAllAndAll = false;
              }
              selectedCombinations.push({ localeId: localeId, touchPointId: touchPointId });
            }, this);
          }, this);

          if (!safeToAddAllAndAll) {
            //one of the user selected combination is <AllTouchpoints, AllLocales> and there is already atleast one suppressed
            //pair. Before adding All and All, all existing pairs should be deleted.
            this.exampleModel.message = $.t("topic.example.suppressedPair.deleteAllPairs");
            this._clearSelectionAndRender();
            return;
          }
          let numOfNewPairsAdded = 0;
          let numOfRedundantPairs = 0;
          let numOfRedundantPairsDeleted = 0;
          const localesToDeleteFromPairs = [];
          const touchpointsToDeleteFromPairs = [];
          const combosToAddLater = [];
          let waitBeforeAddingNewPair;
          selectedCombinations.forEach(function (combo) {
            let combo_exists = false;
            waitBeforeAddingNewPair = false;
            this.autocompleteSuppressedPairs.each(function (pair) {
              if (
                !combo_exists &&
                pair.get("languageId") === combo.localeId &&
                pair.get("touchPointId") === combo.touchPointId
              ) {
                //combo already exists, do not add again
                combo_exists = true;
                numOfRedundantPairs += 1;
                return false;
              }
              if (
                !combo_exists &&
                pair.get("languageId") === this.allLocaleId &&
                pair.get("touchPointId") === combo.touchPointId
              ) {
                //one of the suppressed pair is <SelectedTouchpoint, AllLocales> and the user is trying to add
                // <SelectedTouchpoint, SelectedLocale> pair which is already covered by <SelectedTouchpoint, AllLocales>
                combo_exists = true;
                numOfRedundantPairs += 1;
                return false;
              }
              if (
                !combo_exists &&
                pair.get("languageId") === combo.localeId &&
                pair.get("touchPointId") === this.allTouchPointId
              ) {
                //one of the suppressed pair is <AllTouchpoints, SelectedLocale> and the user is trying to add
                // <SelectedTouchpoint, SelectedLocale> pair which is already covered by <AllTouchpoints, SelectedLocale>
                combo_exists = true;
                numOfRedundantPairs += 1;
                return false;
              }
              if (
                !waitBeforeAddingNewPair &&
                pair.get("languageId") === combo.localeId &&
                combo.touchPointId === this.allTouchPointId
              ) {
                //one of the already suppressed pair is <SomeTouchpoint, SelectedLocale> and the user is trying to add
                //<AllTouchpoint, SelectedLocale>. Existing pair should be deleted before adding new pair.
                //Prompt the user and inform about the deletion
                waitBeforeAddingNewPair = true;
                combosToAddLater.push(combo);
                localesToDeleteFromPairs.push(combo.localeId);
                return false;
              }
              if (
                !waitBeforeAddingNewPair &&
                combo.localeId === this.allLocaleId &&
                pair.get("touchPointId") === combo.touchPointId
              ) {
                //one of the already suppressed pair is <SelectedTouchpoint, SomeLocale> and the user is trying to add
                //<SelectedTouchpoint, SomeLocale>. Existing pair should be deleted before adding new pair.
                //Prompt the user and inform about the deletion
                waitBeforeAddingNewPair = true;
                combosToAddLater.push(combo);
                touchpointsToDeleteFromPairs.push(combo.touchPointId);
                return false;
              }
            }, this);
            if (!combo_exists && !waitBeforeAddingNewPair) {
              //locale-touchpoint pair does not exist, add to the list
              //function createNewPair will mark the model dirty
              this.addNewPair(combo);
              numOfNewPairsAdded += 1;
            }
          }, this);
          if (combosToAddLater.length > 0) {
            const message = $.t("topic.example.suppressedPair.deleteRedundantPairs");
            const ths = this;
            Messenger.yesNoDialog(
              message,
              {
                yes: function () {
                  Messenger.vent.trigger("track:interaction", {
                    action: "Delete Redundant Suppressed Pairs",
                    object: "Suppressed Pair",
                  });
                  let m;
                  m = ths.deleteSuppressedPairsWithLocaleIds(localesToDeleteFromPairs);
                  numOfRedundantPairsDeleted += m;
                  m = ths.deleteSuppressedPairsWithTouchpointIds(touchpointsToDeleteFromPairs);
                  numOfRedundantPairsDeleted += m;
                  combosToAddLater.forEach(function (combo) {
                    ths.addNewPair(combo);
                    numOfNewPairsAdded += 1;
                  });
                  //ths.exampleModel.message = "Added " + numOfNewPairsAdded + " pairs for suppression";
                  ths._setAddedNewPairInfoMessage(
                    numOfNewPairsAdded,
                    numOfRedundantPairs,
                    numOfRedundantPairsDeleted,
                  );
                  ths._clearSelectionAndRender();
                },
                no: function () {
                  //ths.exampleModel.message = "Added " + numOfNewPairsAdded + " pairs for suppression";
                  ths._setAddedNewPairInfoMessage(
                    numOfNewPairsAdded,
                    numOfRedundantPairs,
                    numOfRedundantPairsDeleted,
                  );
                  ths._clearSelectionAndRender();
                },
              },
              this,
            );
          } else {
            //this.exampleModel.message = "Added " + numOfNewPairsAdded + " pairs for suppression";
            this._setAddedNewPairInfoMessage(
              numOfNewPairsAdded,
              numOfRedundantPairs,
              numOfRedundantPairsDeleted,
            );
            //clear the selection after adding new pairs, remember the selections are only for supporting
            //multi-selection. Actual suppressed locales and touchpoints are represented by suppressedPairs
            this._clearSelectionAndRender();
          }
        },
        this,
      );

      this.view.on(
        "delete:suppressed:pair",
        function (id) {
          Messenger.yesNoDialog(
            "topic.example.suppressedPair.confirmDelete",
            {
              yes: function () {
                Messenger.vent.trigger("track:interaction", {
                  action: "Delete Suppressed Pairs",
                  object: "Suppressed Pair",
                });
                const localeId = parseInt(id.split("_")[0], 10);
                const touchpointId = parseInt(id.split("_")[1], 10);
                let pairToDelete;
                _this.autocompleteSuppressedPairs.each(function (pair) {
                  if (
                    pair.get("languageId") === localeId &&
                    pair.get("touchPointId") === touchpointId
                  ) {
                    //delete this pair
                    pairToDelete = pair;
                    return false; //break the loop
                  }
                });
                _this.autocompleteSuppressedPairs.remove(pairToDelete);
                //pairToDelete.destroy();
                _this.autocompleteSuppressedPairs.dirty = true;
                //Messenger.vent.trigger("example:is:dirty");
                _this.view.render();
              },
            },
            this,
          );
        },
        this,
      );

      this.view.on(
        "delete:all:suppressed:pairs",
        function () {
          Messenger.yesNoDialog(
            "topic.example.suppressedPair.confirmAllDelete",
            {
              yes: function () {
                Messenger.vent.trigger("track:interaction", {
                  action: "Delete All Suppressed Pairs",
                  object: "Suppressed Pair",
                });
                _this._removeAllPairs();
                _this.exampleModel.message = $.t(
                  "topic.example.suppressedPair.allPairDeletedMessage",
                );
                const autocompleteSuppressed = !example.get("autocompleteSuppressed");
                example.set("autocompleteSuppressed", autocompleteSuppressed);
                _this.updateFlags();
                _this.view.render();
              },
            },
            this,
          );
        },
        this,
      );

      this.view.on("toggle:onlyAuthoredLocale", function () {
        // Only Authored Locale checkbox was clicked
        const onlyAuthoredLocale = !example.get("onlyAuthoredLocale");
        example.set("onlyAuthoredLocale", onlyAuthoredLocale);
      });

      this.showRegion(this.view);
    },
    _setAddedNewPairInfoMessage: function (n, m, d) {
      if (n === 1 && d === 1 && m === 0) {
        this.exampleModel.message =
          "Added " + n + " pair for suppression, deleted " + d + " already suppressed pair";
      } else if (n === 1 && d > 1 && m === 0) {
        this.exampleModel.message =
          "Added " + n + " pair for suppression, deleted " + d + " already suppressed pairs";
      } else if (n > 1 && d === 1 && m === 0) {
        this.exampleModel.message =
          "Added " + n + " pairs for suppression, deleted " + d + " already suppressed pair";
      } else if (n > 1 && d > 1 && m === 0) {
        this.exampleModel.message =
          "Added " + n + " pairs for suppression, deleted " + d + " already suppressed pairs";
      } else if (n === 1 && m === 0) {
        this.exampleModel.message = "Added " + n + " pair for suppression";
      } else if (n === 1 && m === 1) {
        this.exampleModel.message =
          "Added " + n + " pair for suppression, " + m + " pair are already suppressed";
      } else if (n === 1 && m > 1) {
        this.exampleModel.message =
          "Added " + n + " pair for suppression, " + m + " pairs are already suppressed";
      } else if (n > 1 && m === 0) {
        this.exampleModel.message = "Added " + n + " pairs for suppression";
      } else if (n === 0 && m === 1) {
        this.exampleModel.message = $.t(
          "topic.example.suppressedPair.selectedPairAlreadySuppressed",
        );
      } else if (n === 0 && m > 1) {
        this.exampleModel.message = m + " pairs are already suppressed";
      } else if (n > 1 && m > 1) {
        this.exampleModel.message =
          "Added " + n + " pairs for suppression, " + m + " pairs are already suppressed";
      } else if (n === 0 || m === 0 || d === 0) {
        //reset the message
        this.exampleModel.message = "";
      }
    },
    addNewPair: function (combo) {
      const newPair = this.autocompleteSuppressedPairs.createNewPair();
      newPair.set("languageId", combo.localeId);
      newPair.set("touchPointId", combo.touchPointId);
      if (combo.localeId === this.allLocaleId) {
        newPair.set("languageName", this.allLocaleName);
      } else {
        newPair.set("languageName", this.languages.findWhere({ id: combo.localeId }).get("name"));
      }
      if (combo.touchPointId === this.allTouchPointId) {
        newPair.set("touchPointName", this.allTouchPointName);
      } else {
        newPair.set(
          "touchPointName",
          this.touchPoints.findWhere({ touchPointId: combo.touchPointId }).get("touchPoint"),
        );
      }

      if (combo.localeId === -1) {
        //All option selected for locale
        newPair.set("allLocalesSuppressed", true);
      }
      if (combo.touchPointId === -1) {
        //All option selected for touchpoints
        newPair.set("allTouchpointsSuppressed", true);
      }
    },
    deleteSuppressedPairsWithLocaleIds: function (ids) {
      let numOfPairsDeleted = 0;
      if (ids.length > 0) {
        const modelsToDelete = [];
        let locId;
        ids.forEach(function (localeId) {
          locId = localeId;
          this.autocompleteSuppressedPairs.each(function (pair) {
            if (pair.get("languageId") === locId) {
              modelsToDelete.push(pair);
            }
          }, this);
        }, this);
        modelsToDelete.forEach(function (model) {
          this.autocompleteSuppressedPairs.remove(model);
          this.autocompleteSuppressedPairs.dirty = true;
          numOfPairsDeleted += 1;
        }, this);
      }
      return numOfPairsDeleted;
    },
    deleteSuppressedPairsWithTouchpointIds: function (ids) {
      let numOfPairsDeleted = 0;
      if (ids.length > 0) {
        const modelsToDelete = [];
        let tpId;
        ids.forEach(function (touchpointId) {
          tpId = touchpointId;
          this.autocompleteSuppressedPairs.each(function (pair) {
            if (pair.get("touchPointId") === tpId) {
              modelsToDelete.push(pair);
            }
          }, this);
        }, this);
        modelsToDelete.forEach(function (model) {
          this.autocompleteSuppressedPairs.remove(model);
          this.autocompleteSuppressedPairs.dirty = true;
          numOfPairsDeleted += 1;
        }, this);
      }
      return numOfPairsDeleted;
    },
    _clearSelectionAndRender: function () {
      this._suppressNoLocales();
      this._suppressNoTouchPoints();
      this.view.render();
    },
    buildAutocompleteSuppressedLocales: function () {
      const languages = this.languages;
      const autocompleteSuppressedLocales = languages.map(function (language) {
        return {
          languageId: language.get("id"),
          languageName: language.get("name"),
          suppressed: false,
        };
      });

      return [
        {
          languageId: this.allLocaleId,
          languageName: "All",
          suppressed: false,
        },
      ].concat(autocompleteSuppressedLocales);
    },
    buildAutocompleteSuppressedTouchPoints: function () {
      const touchPoints = this.touchPoints;
      const autocompleteSuppressedTouchPoints = touchPoints.map(function (touchPoint) {
        return {
          touchPointId: touchPoint.get("touchPointId"),
          touchPointName: touchPoint.get("touchPoint"),
          suppressed: false,
        };
      });

      return [
        {
          touchPointId: this.allTouchPointId,
          touchPointName: "All",
          suppressed: false,
        },
      ].concat(autocompleteSuppressedTouchPoints);
    },
    updateAutoCompleteSuppressedStatus: function () {
      if (this.anyLocaleSuppressed) {
        this.exampleModel.set("autocompleteSuppressed", true);
      }
    },
    updateFlags: function () {
      if (!this.exampleModel.get("autocompleteSuppressed")) {
        //"suppress from autocomplete" box has been unchecked
        this.exampleModel.set("autoCompleteSuppressedLocalesFlag", false);
        this.exampleModel.set("autoCompleteSuppressedTouchpointsFlag", false);
      } else {
        //"suppress from autocomplete" box has been checked
        this.exampleModel.set("autoCompleteSuppressedLocalesFlag", true);
        this.exampleModel.set("autoCompleteSuppressedTouchpointsFlag", true);
      }
    },
    getSuppressionStatus: function () {
      return this.view.getSuppressionStatus();
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "example:is:dirty",
        function () {
          this.exampleModel.dirty = true;
        },
        this,
      );
    },
    _suppressNoLocales: function () {
      _.each(this.autocompleteSuppressedLocales, function (locale) {
        locale.suppressed = false;
      });
    },
    _suppressNoTouchPoints: function () {
      _.each(this.autocompleteSuppressedTouchPoints, function (touchPoint) {
        touchPoint.suppressed = false;
      });
    },
    _removeAllPairs: function () {
      let collectionNonEmpty = true;
      while (collectionNonEmpty) {
        const model = this.autocompleteSuppressedPairs.first();
        if (model) {
          collectionNonEmpty = true;
          this.autocompleteSuppressedPairs.remove(model);
          this.autocompleteSuppressedPairs.dirty = true;
        } else {
          collectionNonEmpty = false;
        }
      }
    },
  });
});
